export default function initDisableIfNoValue() {
    document.querySelectorAll<HTMLElement>('[data-disabled-if-no-value]').forEach($el => {
        const fieldId = $el.dataset.disabledIfNoValue || '';
        const $field = document.getElementById(fieldId);

        if ($field instanceof HTMLSelectElement || $field instanceof HTMLInputElement) {
            new DisableIfNoValue($el, $field);
        }
    });
}

/**
 * Ajoute l'attribut "disabled" sur un élément lorsque un champ (input ou select) est vide
 * À l'inverse, retire l'attribut lorsque le champ est rempli.
 * 
 * Utilisation :
 * 
 * <select id="mon-select"></select>
 * <button data-disabled-if-no-value="mon-select">Valider</button>
 */
class DisableIfNoValue {
    $el: HTMLElement;
    $field: HTMLInputElement | HTMLSelectElement;

    constructor($el: HTMLElement, $field: HTMLInputElement | HTMLSelectElement) {
        this.$el = $el;
        this.$field = $field;

        this.onInputChangeHandler();
        this.$field.addEventListener('change', this.onInputChangeHandler.bind(this));
    }

    /**
     * Ajoute l'attribut "disabled" à $el si $field n'a aucune valeur
     * 
     * @return {void}
     */
    onInputChangeHandler() : void {
        let hasValue = !!this.$field.value;

        if (this.$field instanceof HTMLSelectElement) {
            const $placeHolderOption = this.$field.querySelector<HTMLOptionElement>('option[data-placeholder]');
            if ($placeHolderOption) {
                hasValue = this.$field.value !== $placeHolderOption.value;
            }
        }

        if (hasValue) {
            this.$el.removeAttribute('disabled');
        } else {
            this.$el.setAttribute('disabled', 'disabled');
        }
    }
}
